<template>
  <div class="customer-scoring-page">
    <!--   能力评分容器  -->
    <div class="score-container-view">
      <div class="score-title">全国冷暖风水服务能力评分</div>
      <div class="score-end-time">统计截止时间：{{ deadline }}</div>
      <!--      分数容器      -->
      <!-- <div class="score-container">
        <div class="score-item" v-for="item in arrScoreList" :key="item.name">
          <p class="value">{{ item.value }}</p>
          <p class="name">{{ item.name }}</p>
        </div>
      </div> -->
    </div>
    <!--     子路由导航   -->
    <div class="nav-container-view" style="margin-top:80px">
      <div
        class="nav-item"
        :class="{ 'active-nav-item': nav.active }"
        @click="navToRouter(nav.path)"
        v-for="nav in arrNavList"
        :key="nav.path"
      >
        {{ nav.name }}
      </div>
      <div class="liner-to-left" :class="{ 'liner-to-right': arrNavList[2].active,'liner-to-center': arrNavList[1].active }"></div>
    </div>

    <!--   子路由视图     -->
    <router-view></router-view>
  </div>
</template>

<script>
import oStorage from '@/libsV2/storage.js';
import { getEarthScore } from "@/js/service.js";
import { log } from "@antv/g2plot/lib/utils";
import {fetchVerifyAuthForB} from '@/libsV2/havc.js';
export default {
  name: "index",
  data() {
    return {
      // 截止时间
      deadline: "",
      // 分数渲染数组
      arrScoreList: [
        {
          name: "项目服务评分",
          value: "",
        },
        {
          name: "用户满意评分",
          value: "",
        },
        {
          name: "综合服务评分",
          value: "",
        },
      ],
      // 子路由导航数组
      arrNavList: [
        {
          name: "服务能力评分",
          path: "/hvac/customerscoring/analysis/score",
          active: true,
        },
        {
          name: "项目评分明细",
          path: "/hvac/customerscoring/particulars",
        },
        {
          name: "高频问题排名",
          path: "/hvac/customerscoring/question",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
    console.log(to.path,'path')
        if(to.path==='/hvac/customerscoring/question'){
                this.initRouteLinkClass(to.path)
        }else if(to.path==='/hvac/customerscoring/analysis/score' || to.path==='/hvac/customerscoring/analysis/ranking' ){
              this.initRouteLinkClass(to.path)
        }else if(to.path==='/hvac/customerscoring/particulars'){
           this.initRouteLinkClass(to.path)
        }
    },
  },
  created(){

    fetchVerifyAuthForB(()=>{
        this.$store.commit("loadSwitch", true);
        this.getThreeList()
        this.initRouteLinkClass()
    })
  },
  mounted() {
    //   获取路由上的salesid
    //  this.sSalesid = this.$route.query.salesid
    //   this.$store.commit("loadSwitch", true);
    // oRequest.fetchVerifyAuthForB(()=>{
    //     this.getThreeList()
    //     this.initRouteLinkClass()
    // })
    // $init(() => {
    //   this.$store.commit("loadSwitch", true);
    //   Promise.all([this.getThreeList(), this.initRouteLinkClass()]).then((res) => {
    //   });
    // });
  },
  methods: {
    getThreeList() {
      // 获取首页三项评分
      getEarthScore().then((res) => {
          this.$store.commit("loadSwitch", false);
        this.deadline = res.data.data.result.time;
        this.arrScoreList[0].value = res.data.data.result.service_score;
        this.arrScoreList[1].value = res.data.data.result.customer_score;
        this.arrScoreList[2].value = res.data.data.result.composite_score;
      });
    },
    /**
     * 导航点击
     * @param { string } path
     */
    async navToRouter(path) {
      if(path!='/hvac/customerscoring/particulars'){
        await this.$router.push(path);
        await this.initRouteLinkClass(path);
      }else{
        await this.$store.commit("editCompanyId", '');
        // await localStorage.setItem('companyId', '');
        await oStorage.setStorage('companyId', '');
         await this.initRouteLinkClass(path);
        await this.$router.push({path:path,params:{company:false}});
      }

    },
    /**
     * 设置路由的激活样式
     */
    initRouteLinkClass(_path) {
      const path = _path ?? this.$route.path;
      this.arrNavList = this.arrNavList.map((i) => {
        i.active = false;
        i.path === path && (i.active = true);
        return i;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.customer-scoring-page {
  min-height: 100vh;
  color: $commonText;
  overflow: auto;
  scroll-behavior: smooth;
  background: $defaultBackgroundGary url("../../../assets/images/service/service-background.png") no-repeat left top / 100% 228px;
  padding: 28px 24px 10px;

  .score-container-view {
    margin-bottom: 40px;
    font-size: $smallSize;

    .score-title {
      font-size: $bigSize;
      color: #ffffff;
      font-weight: 500;
      line-height: 44px;
      margin-bottom: 12px;
    }

    .score-end-time {
      color: rgba(#fff, 0.8);
      line-height: 34px;
      margin-bottom: 28px;
    }

    .score-container {
      background: #ffffff;
      padding: 26px 26px 34px;
      border-radius: $commonRadius;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .score-item {
        flex: 0 0 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .value {
          font-size: 60px;
          line-height: 84px;
          color: $deepGreen;
          font-weight: 500;
        }

        .name {
          line-height: 36px;
        }
      }
    }
  }

  .nav-container-view {
    display: flex;
    justify-content:space-between;
    align-items: center;
    padding-bottom: 16px;
    position: relative;
    margin-bottom: 28px;

    .liner-to-left {
      position: absolute;
      width: 140px;
      height: 6px;
      bottom: 0;
      left: 50px;
      background: $deepGreen;
      transition: all 0.5s;
    }

    .liner-to-right {
      left: 510px;
    }
    .liner-to-center {
      left: 280px;
    }

    .nav-item {
      flex: 1;
      font-size: $bigSize;
      line-height: 44px;
      color: #858585;
      font-weight: 400;
      text-align: center;
    }

    .active-nav-item {
      color: $deepGreen;
      font-weight: 500;
    }

    .active-nav-item-black {
      color: $commonText;
      font-weight: 500;
    }
  }
}
</style>
